<template>
  <div class="mt-80 ml-220 pt-3">
    <b-button-group>
      <b-button @click="mode = 'All'">Все</b-button>
      <b-button variant="success" @click="mode = 'New'">Новые</b-button>
      <b-button variant="primary" @click="mode = 'Been_read'">Прочитанные</b-button>
    </b-button-group>
    <div v-if="loading"  class="loader pt-100">
      <b-spinner label="Spinning" variant="primary"></b-spinner>
    </div>
    <div class="requests pb-3 pt-3" v-else>
      <div
        class="request-item"
        v-for="(request, id) in filterRequests" :key="id">
       <div
         class="p-2"
         :class="[!request.been_read ? 'bg-unread' : '']">
         <div>{{request.name}}</div>
         <div>{{request.mail}}</div>
         <div>{{request.number}}</div>
         <div>{{request.problem}}</div>
         <div class="d-flex mt-2 justify-content-center">
           <b-button variant="danger" @click="onDelete(request.id)" class="mr-2 btn-width" size="sm">Удалить</b-button>
           <b-button size="sm" variant="primary" @click="readRequest(request.id)" v-if="request.been_read === false" class="btn-width" v-b-tooltip="'Поместить в прочитанные'">Прочитать</b-button>
           <b-button size="sm" variant="primary" @click="unreadRequest(request.id)" v-else class="btn-width" v-b-tooltip="'Поместить в непрочитанные'">Вернуть</b-button>
         </div>
       </div>
      </div>
    </div>
    <div>
      <b-modal
         id="deleteModal"
         size="sm"
         centered
         hide-footer
         hide-header>
        <div class="d-block mb-3 text-center">
         <h3> Удалить заявку?</h3>
        </div>
        <div class="d-flex justify-content-center">
          <b-button variant="success" class="mr-2" @click="DeleteRequest()">Удалить</b-button>
          <b-button variant="primary" @click="$bvModal.hide('deleteModal')">Отмена</b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  export default {
    name: "AdminRequestPage",
    data() {
      return {
        loading: true,
        mode: 'All',
        currentRequest: null
      }
    },
    async mounted() {
      this.loading = true;
      await this.fetchRequests()
      this.loading = false;
    },
    computed: {
      ...mapState('request', ['requests']),
      filterRequests() {
        if(this.mode === 'All') {
          return this.requests
        }
        if(this.mode === 'New') {
          return this.requests.filter(r => r.been_read === false)
        }
        if(this.mode === 'Been_read') {
         return  this.requests.filter(r => r.been_read === true)
        }
      }
    },
    methods: {
      ...mapActions('request', ['fetchRequests', 'deleteRequest', 'readRequest', 'unreadRequest']),
      onDelete(id) {
        this.currentRequest = id
        this.$bvModal.show('deleteModal')
      },
      DeleteRequest() {
        this.deleteRequest(this.currentRequest)
        this.$bvModal.hide('deleteModal')
      },
    }
  }
</script>

<style lang="scss">
  .requests {
    width: 100%;
    display: block;
    .request-item {
      padding: 12px 0px 12px;
      border-bottom: 1px solid #7e7e7e;
    }
    .bg-unread {
      background: rgba(0,128,0, 0.3);
    }
  }
</style>